import { Button, Modal, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import Periods from "../Enums/Periods";
import { InfinityPagination } from "../hooks/Pagination";
import { CandidateSearch, CandidateTable } from "../interfaces/Candidate";
import { LetterCreate } from "../interfaces/Letter";
import {
	LetterTemplateSearch,
	LetterTemplateTable,
} from "../interfaces/LetterTemplate";
import { RequestTable } from "../interfaces/Request";
import { VacancySearch, VacancyTable } from "../interfaces/Vacancy";
import {
	CreateLetter,
	GetCandidates,
	GetLetterTemplates,
	GetVacancies,
} from "../requester/functions";
import { getFullName } from "../utilities/string";
import VO, { NotEmpty } from "../utilities/validate";
import DataDateTime from "./DataInputs/DataDateTime";
import DataMultiSelect from "./DataInputs/DataMultiSelect";
import DataSelect from "./DataInputs/DataSelect";
import DataSwitch from "./DataInputs/DataSwitch";

const template: LetterCreate = {
	id_template: 0,
	start_date: undefined,
	all_candidates: true,
};

interface IProps {
	open: boolean;
	onClose(): void;
	onCreate?(): void;
	request?: RequestTable;
}

const CreateMailingModal = (props: IProps) => {
	const { enqueueSnackbar } = useSnackbar();

	const [letter, setLetter] = useState<LetterCreate>(template);
	const [templates, setTemplates] = useState<LetterTemplateTable[]>([]);
	const [vacancies, setVacancies] = useState<VacancyTable[]>([]);
	const [candidates, setCandidates] = useState<CandidateTable[]>([]);

	const [searchTemplate, setSearchTemplate] = useState<LetterTemplateSearch>(
		{}
	);
	const [searchVacancy, setSearchVacancy] = useState<VacancySearch>({});
	const [searchCandidate, setSearchCandidate] = useState<CandidateSearch>({});

	useEffect(() => {
		setLetter((t) => {
			if (props.request) t.id_request = props.request?.id;
			else if (t.id_request) delete t.id_request;
			return { ...t };
		});
	}, [props.request]);

	useEffect(() => {
		GetLetterTemplates(
			{
				search_by: searchTemplate,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setTemplates(resp.data.data);
				}
			}
		);
	}, [searchTemplate]);

	useEffect(() => {
		GetVacancies(
			{
				filter_by: { all_vacancies: true },
				search_by: searchVacancy,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setVacancies(resp.data.data);
				}
			}
		);
	}, [searchVacancy]);

	useEffect(() => {
		GetCandidates(
			{
				search_by: searchCandidate,
				pagination: InfinityPagination,
			},
			(resp) => {
				if (resp.status === "ok" && resp.data) {
					setCandidates(resp.data.data);
				}
			}
		);
	}, [searchCandidate]);

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			className="flex items-center  flex-col justify-center  overflow-auto"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[800px] min-w-[400px]  flex flex-col gap-5">
				<Typography variant="h4">Создание рассылки</Typography>
				<DataSelect
					label="Шаблон"
					list={templates}
					value={letter}
					setValue={setLetter}
					keyValue={"id_template"}
					inputProps={{ required: true }}
				/>
				{props.request ? (
					<Paper className="flex flex-col gap-2 p-1">
						<Typography>Заявка</Typography>
						<Typography>
							{props.request.candidate.full_name} / {props.request.vacancy.name}
						</Typography>
					</Paper>
				) : (
					<>
						<DataSelect
							label="Вакансия"
							list={vacancies}
							value={letter}
							setValue={setLetter}
							keyTitle={"name"}
							keyValue={"id_vacancy"}
						/>
						<DataMultiSelect
							label="Кандидаты"
							list={candidates}
							value={letter}
							setValue={(obj: any) => {
								setLetter({
									...obj,
									all_candidates: !NotEmpty((obj as LetterCreate).candidates),
								});
							}}
							keyItemValue={"id"}
							keyItemTitle={"last_name"}
							renderItemTitle={(item: CandidateTable) =>
								getFullName(item.last_name, item.first_name, item.patronymic)
							}
							keyValue={"candidates"}
						/>
						<DataSwitch
							keyValue={"all_candidates"}
							value={letter}
							setValue={setLetter}
							label="Отправить всем кандидатам"
							inputProps={{ disabled: true }}
						/>
						<DataSelect
							label="Периодичность"
							list={Periods}
							value={letter}
							setValue={setLetter}
							keyTitle={"name"}
							keyItem={"timestamp"}
							keyValue={"period"}
						/>
					</>
				)}

				<DataDateTime
					value={letter}
					setValue={setLetter}
					label="Дата и время отправки"
					keyValue={"start_date"}
					inputProps={{ required: true }}
				/>

				<Button
					disabled={!VO(letter, template)}
					variant="contained"
					onClick={() => {
						CreateLetter({ ...letter }, (resp) => {
							if (resp.status === "ok") {
								enqueueSnackbar("Рассылка создана", {
									variant: "success",
								});
								props.onCreate?.();
								props.onClose();
							} else {
								enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
									variant: "error",
								});
							}
						});
					}}
				>
					Сохранить
				</Button>
			</Paper>
		</Modal>
	);
};

export default CreateMailingModal;
